export const routingModulePaths = {
	insufficientPermissions: 'insufficient-permissions',
	privacy: 'privacy',
	cookies: 'cookies',
	terms: 'terms',
	refundPolicy: 'refund-policy',
	login: 'login',
	unsubscribe: 'unsubscribe',
	forgottenPassword: 'forgotten-password',
	confirmEmail: 'confirm-email',
	resetPassword: 'reset-password',
	signup: 'signup',
	logout: 'logout',
	empty: 'empty',
	error: 'error'
} as const;
